export function getDimensionsConstrainedToContainer(
    elementDimensions: Dimensions,
    containerDimensions: Dimensions
) {
    if (
        elementDimensions.width < containerDimensions.width &&
        elementDimensions.height < containerDimensions.height
    ) {
        return elementDimensions;
    }

    const widthScale = containerDimensions.width / elementDimensions.width;
    const heightScale = containerDimensions.height / elementDimensions.height;
    const scale = Math.min(widthScale, heightScale);

    return {
        width: Math.floor(elementDimensions.width * scale),
        height: Math.floor(elementDimensions.height * scale),
    };
}
export default getDimensionsConstrainedToContainer;
